
import './App.css';
import { Routes, Route } from 'react-router-dom';
import ExploreCampaign from './pages/ExploreCampaign';
import DonateMonthly from './pages/DonateMonthly';
import About from './pages/About';
import Home from './pages/Home';
import Navbar from './components/navbar/Navbar';
import Footer from './components/footer/Footer';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsService from './pages/TermsService';
import RefundPolicy from './pages/RefundPolicy';
import Account from './pages/Account';
import Product from './pages/Product';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Donar from './pages/Donar';
import Login from './pages/Login';
import OtpLogin from './pages/OtpLogin';
import Profile from './pages/Profile';
import Volunteer from './pages/Volunteer';
import RandomProduct from './pages/RandomProduct';
import MyDonate from './pages/MyDonate';
import ReferDonate from './pages/ReferDonate';
import SupportCall from './pages/SupportCall';
import PrivateRoute from './components/PrivateRoute';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function App() {
  return (

    <div >
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/explore-campaign' element={<ExploreCampaign />} />
        <Route path='/Donate-monthly' element={<DonateMonthly />} />
        <Route path='/about' element={<About />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/terms-service' element={<TermsService />} />
        <Route path='/refund-policy' element={<RefundPolicy />} />
        <Route path='/product/:productId' element={<Product />} />
        <Route path='/cart' element={<Cart />} />
        <Route path='/checkout' element={<Checkout />} />
        <Route path='/checkout/donar' element={<Donar />} />
        <Route path='/login' element={<Login />} />
        <Route path='/otp-login' element={<OtpLogin />} />
        <Route path='/profile' element={<Profile />} />
        <Route path='/volunteer' element={<Volunteer />} />
        <Route path='/random-product' element={<RandomProduct />} />
        <Route path='/my-donate' element={<MyDonate />} />
        <Route path='/refer-donate' element={<ReferDonate />} />
        <Route path='/support-call' element={<SupportCall />} />

        {/* Private Routes */}
        <Route element={<PrivateRoute />}>
          <Route path='/account' element={<Account />} /> 
          <Route path='/profile' element={<Profile />} />
        </Route>
      </Routes>
      <Footer />

    </div>

  );
}

export default App;
